import React, { FC, CSSProperties } from 'react'
import styled from 'styled-components'
import { BaseButton } from '../buttons'
import PlayButtonIcon from '@tuhi/components/assets/icons/audioPlayer/playIcon.svg'
import PauseButtonIcon from '@tuhi/components/assets/icons/audioPlayer/pauseIcon.svg'
import ForwardButtonIcon from '@tuhi/components/assets/icons/audioPlayer/forwardIcon.svg'
import BackButtonIcon from '@tuhi/components/assets/icons/audioPlayer/backIcon.svg'
import Forward10Icon from '@tuhi/components/assets/icons/audioPlayer/forward10Icon.svg'
import Back10Icon from '@tuhi/components/assets/icons/audioPlayer/replay10Icon.svg'

const style: CSSProperties = {
    fontSize: '32px',
    cursor: 'pointer',
}

const Button = styled(BaseButton)`
    color: ${(p) => p.theme.colors.mediumGrey};

    &:active {
        transform: scale(1.1);
        color: ${(p) => p.theme.colors.primaryGreen};
    }
`

const PlayButton = styled(Button)`
    width: 48px;
    height: 48px;
`

interface Props {
    onClick: () => void
}

export const AudioPlayButton: FC<Props> = ({ onClick }) => {
    return (
        <PlayButton onClick={onClick}>
            <PlayButtonIcon />
        </PlayButton>
    )
}

export const AudioPauseButton: FC<Props> = ({ onClick }) => {
    return (
        <PlayButton onClick={onClick}>
            <PauseButtonIcon />
        </PlayButton>
    )
}

export const AudioPlayBackButton: FC<Props> = ({ onClick }) => {
    return (
        <Button onClick={onClick}>
            <BackButtonIcon />
        </Button>
    )
}

export const AudioPlayForwardButton: FC<Props> = ({ onClick }) => {
    return (
        <Button onClick={onClick}>
            <ForwardButtonIcon />
        </Button>
    )
}

export const AudioPlayForward10Button: FC<Props> = ({ onClick }) => {
    return (
        <Button onClick={onClick}>
            <Forward10Icon />
        </Button>
    )
}

export const AudioPlayBackward10Button: FC<Props> = ({ onClick }) => {
    return (
        <Button onClick={onClick}>
            <Back10Icon />
        </Button>
    )
}
